import { Button, Input } from "components"
import { Box } from "theme-ui"
import "./style/style.css"

export const SignalGroups = () => {
 return (
  <div className="w-full mx-auto pt-2 transition-all">
   <h1 className="font-semibold text-lg Jakarta-font ">Messages</h1>
   <Box bg="highlight" color="text-black" className="px-4 py-3 mt-2">
    <h1 className="font-semibold text-lg Jakarta-font ">Period of Time</h1>
    <div className="mt-4">
     <div className="flex justify-between lg:flex-row flex-col ">
      <div className="flex flex-col lg:w-[28%] w-full Jakarta-font lg:pb-0 pb-4 ">
       <Input className="outline-none bg-gray text-black py-3 rounded px-3" label="Beginning" type="date" />
      </div>
      <div className="flex flex-col lg:w-[28%] w-full Jakarta-font lg:pb-0 pb-4 ">
       <Input className="outline-none bg-gray text-black py-3 rounded px-3" label="End" type="date" />
      </div>
      <div className="lg:w-[38%] w-full Jakarta-font ">
       <h1>Messages:</h1>

       <div className="flex w-full justify-between pt-3 Jakarta-font ">
        <div className="w-[12%] flex items-center">
         <Input
          className="customradio"
          type="radio"
          id="first-radiobutton"
          name="commonradiobutton"
         />
         <label className="pl-2" htmlFor="first-radiobutton">
          All
         </label>
        </div>

        <div className="w-[40%] flex items-center">
         <Input
          className="customradio"
          type="radio"
          id="second-radiobutton"
          name="commonradiobutton"
         />
         <label className="pl-2" htmlFor="second-radiobutton">
          with Redirects
         </label>
        </div>
        <div className="w-[40%] flex items-center">
         <Input
          className="customradio"
          type="radio"
          id="third-radiobutton"
          name="commonradiobutton"
         />
         <label className="pl-2" htmlFor="third-radiobutton">
          with Redirects
         </label>
        </div>
       </div>
      </div>
     </div>

     <div className="flex justify-between lg:flex-row flex-col mt-4">
      <div className=" lg:w-[65%] w-full flex items-center">
       <div className="w-full Jakarta-font lg:pb-0 pb-4">
        <h1>Message Text:</h1>
        <div className="bg-gray flex w-full justify-between rounded">
         <Input
          className="bg-gray pl-3 py-3 rounded text-black outline-none w-[70%] "
          type="text"
          placeholder="Enter some text here..."
         />
         <div className="flex items-center justify-between px-4 w-[20%]  my-2 mr-2  bg-light-red py-1 rounded">
          <Input className="inverseradio" id="inverse" name="inverse" type="radio" />
          <label className="ml-2 text-black" htmlFor="inverse">
           Inverse
          </label>
         </div>
        </div>
       </div>
      </div>
      <div className=" lg:w-[32%] w-full Jakarta-font lg:pb-0 pb-4">
       <h1>Grad:</h1>
       <div className="bg-gray flex justify-between py-2 rounded">
        <select className="bg-gray text-black outline-none pr-6 pl-2 w-[50%]">
         <option value="someOption">Some option</option>
         <option value="otherOption">Other option</option>
        </select>
        <div className="flex items-center justify-between w-[40%] px-4 right-2 bg-light-red py-1 rounded mr-2">
         <Input className="inverseradio" id="inverse" name="inverse" type="radio" />
         <label className="ml-2 text-black" htmlFor="inverse">
          Inverse
         </label>
        </div>
       </div>
      </div>
     </div>

     <div className="flex lg:justify-end justify-center mt-4 Jakarta-font">
      <div>
       <Button color={"lightBrown"} size={"xl"}>
        {" "}
        Anzeigen
       </Button>
      </div>

      <div className="ml-2">
       <Button color={"yellow"} size={"xl"}>
        {" "}
        Download
       </Button>
      </div>
     </div>
    </div>
   </Box>
   <div className="bg-light-red flex justify-between lg:flex-row flex-col px-4 py-4 mt-6 border-red border rounded Jakarta-font ">
    <div>
     <h1 className="text-red ">Warning</h1>
     <p className="text-xs lg:py-0 py-2">
      6 planes selected. This can lead to long loading times. Confirm the selection or select few
      attachments
     </p>
    </div>
    <div className="flex lg:justify-end justify-center">
     <div>
      <Button color={"yellow"} size={"xl"}>
       Confirm Selection
      </Button>
     </div>
    </div>
   </div>
  </div>
 )
}
